module.exports = __webpack_public_path__ + "img/osint-horizontal1.2a80283e.png";